import styled from 'styled-components';

export const StyledSelectionActionEmptyInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 10px;
  background-color: #232630;
  border-radius: 12px;
`;
